import React from "react";
import Meaning from "./Meaning.js";
import Phonetics from "./Phonetics.js";
import "./Results.css";

export default function Results(props) {
  if (
    props.results &&
    props.results.word &&
    props.results.meanings &&
    Array.isArray(props.results.meanings)
  ) {
    return (
      <div className="Results">
        <section>
          <h2>
            {props.results.word}
            <span className="viewPhotos">
              <a href="#Photos_id">view photos</a>
            </span>
          </h2>

          <Phonetics word={props.results.word} />
          {props.results.meanings.map(function (meaning, index) {
            return (
              <section key={index}>
                <Meaning meaning={meaning} />
              </section>
            );
          })}
        </section>
      </div>
    );
  } else {
    return null;
  }
}
